import React from 'react';
import { Button, Row } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const BackButton: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Row>
      <Button type='link' icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>
        Back
      </Button>
    </Row>
  );
};

export default BackButton;
